Submenu = {

	isFixed:false,
	menus: {},

	update: function(){
		this.menus = $('nav.submenu.horizontal')
		this.menus.each(function(index, el) {
			Submenu.check($(this))
		});
	},

	check: function(menu){
		var page = menu.closest('.row');
		var top = page.offset().top;

		if ((top < 60) && (top > 60 - page.outerHeight())){
			menu.addClass('fixed');
		} else {
			menu.removeClass('fixed');
		}
	},

	setFixed: function () {

		if (this.isFixed) return;


		this.isFixed = true;
	},

	setAbsolute: function(){

		if (!this.isFixed) return;

		this.isFixed = false;

	}
}